export let ImageKey;
(function (ImageKey) {
  ImageKey["Wordpress"] = "WORDPRESS";
})(ImageKey || (ImageKey = {}));